import { QCONFIG_DETAIL_DATA_TEST_ID } from '@e2e/constants/exam-management';
import {
  AddIcon,
  DeleteOutlineIcon,
  MoreMenuIconButton,
  type MoreMenuIconButtonOption,
  type MoreMenuIconButtonProps,
} from '@shared/components';

import { useQConfigStructureModal } from '../../providers';

interface ChapterTableRowMenuProps extends Omit<MoreMenuIconButtonProps, 'options'> {
  chapterId: string;
  setExpandedRow?: (id: string) => void;
}

export function ChapterTableRowMenu(props: Readonly<ChapterTableRowMenuProps>) {
  const { chapterId, setExpandedRow } = props;
  const { setAction } = useQConfigStructureModal();

  const handleSubmit = () => {
    setExpandedRow?.(chapterId);
  };

  const handleAddSingleQuestions = () => {
    setAction({
      action: 'ADD_SINGLE_QUESTION_CONDITIONS',
      payload: {
        chapterId,
        onSubmit: handleSubmit,
      },
    });
  };

  const handleAddItemSetQuestions = () => {
    setAction({
      action: 'ADD_ITEM_SET_QUESTION_CONDITIONS',
      payload: {
        chapterId,
        onSubmit: handleSubmit,
      },
    });
  };

  const handleRemove = () => {
    setAction({
      action: 'QCONFIG_DELETE',
      payload: { qConfigStructureId: chapterId },
    });
  };

  const chapterMenuOptions: MoreMenuIconButtonOption[] = [
    {
      icon: (
        <AddIcon
          sx={{
            color: (theme) => theme.palette.grey[600],
          }}
        />
      ),
      label: 'Add Single',
      'data-testid': QCONFIG_DETAIL_DATA_TEST_ID.ADD_SINGLE_MENU_ITEM,
      onClick: handleAddSingleQuestions,
      sx: {
        ':hover': {
          backgroundColor: (theme) => theme.palette.primary.lighter,
        },
      },
    },
    {
      icon: (
        <AddIcon
          sx={{
            color: (theme) => theme.palette.grey[600],
          }}
        />
      ),
      label: 'Add Item Set',
      'data-testid': QCONFIG_DETAIL_DATA_TEST_ID.ADD_ITEM_SET_MENU_ITEM,
      onClick: handleAddItemSetQuestions,
      sx: {
        ':hover': {
          backgroundColor: (theme) => theme.palette.primary.lighter,
        },
      },
    },
    {
      icon: (
        <DeleteOutlineIcon
          sx={{
            color: (theme) => theme.palette.error.main,
          }}
        />
      ),
      label: 'Remove',
      'data-testid': QCONFIG_DETAIL_DATA_TEST_ID.REMOVE_CHAPTER_MENU_ITEM,
      onClick: handleRemove,
      sx: {
        color: (theme) => theme.palette.error.main,
        ':hover': {
          backgroundColor: (theme) => theme.palette.primary.lighter,
        },
      },
    },
  ];
  return (
    <MoreMenuIconButton
      options={chapterMenuOptions}
      slotProps={{
        iconButton: { sx: { color: (theme) => theme.palette.grey[500] } },
      }}
    />
  );
}
